
import { Component, Emit, Vue } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";

import { UserPermissions, Region } from "@/store/types";
import { ArmDisarmState, GroupIsOnTestOverride, AreaSelected } from "@/store/arm-disarm-area/types";
import { FilteredEvent, Group } from "@/store/eventqueue/types";

import api from "@/services/api.service";

import PutOnTest from "@/components/alarm-points/PutOnTest.vue";
import { getLocalRegion } from "@/utils/region-utils";

const ArmDisarm = namespace("armDisarm");
const EventQueue = namespace("eventqueue");

@Component({
	components: {
		"put-on-test": PutOnTest
	}
})
export default class GroupIsOnTestModal extends Vue {
	@Getter("getPermissions") private permissions: UserPermissions;

	@ArmDisarm.State((state: ArmDisarmState) => state.selectedGroup) private selectedGroup: Group;
	@ArmDisarm.State((state: ArmDisarmState) => state.selectedRegion) private region: Region;

	@ArmDisarm.Mutation private setGroupIsOnTestModalVisibility: (visible: boolean) => void;
	@ArmDisarm.Mutation private setGroupIsOnTestOverride: (groupIsOnTestOverride: GroupIsOnTestOverride) => void;

	@EventQueue.Getter("getSitesOnTestEvents") private sitesOnTestEvents: FilteredEvent[];

	private areaOnTestEvent: FilteredEvent = null;
	private regionId: number = null;

	private created(): void {
		this.regionId = this.region?.regionId ?? getLocalRegion().regionId;
		this.areaOnTestEvent = this.sitesOnTestEvents.find(
			event => event.groupID === this.selectedGroup.groupID && event.regionID === this.regionId
		);
	}

	private get modalTitle(): string {
		return `${this.selectedGroup.title} - On Test`;
	}

	private handleModalHidden(): void {
		this.setGroupIsOnTestModalVisibility(false);
	}

	@Emit("tree-updated")
	private async handleEndClick(): Promise<AreaSelected> {
		if (this.areaOnTestEvent) {
			await api.endTest(this.areaOnTestEvent.eventID, this.region?.url);
			this.setGroupIsOnTestOverride({
				groupId: this.selectedGroup.groupID,
				onTest: false,
				regionId: this.regionId
			});
		}

		return { groupID: this.selectedGroup.groupID, regionID: this.region?.regionId };
	}

	private handleOnTestExtended(): void {
		this.setGroupIsOnTestModalVisibility(false);
	}

	private get userCanPlaceSitesOnTest(): boolean {
		return this.permissions.canSetSiteToOnTest;
	}
}
